import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface SummaryData {
  totalValue: number;
  totalProduct: number;
  totalQty: number;
}

const InventoryValueCard = () => {
  
  const [summary, setSummary] = useState<SummaryData>({
    totalValue: 0,
    totalProduct: 0,
    totalQty: 0,
  });
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/analytics/inventory_summary`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
    
		setSummary(res.data)
		
      } catch (error) {
        console.error('Error fetching inventory value:', error);
      }
    };

    fetchData();
  }, [API]);

  return (

	  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card title="Total Product" value={summary.totalProduct} color="bg-blue-100" />
		<Card title="Total Qty" value={summary.totalQty} color="bg-blue-100" />
		<Card title="Total Value of Inventory" value={new Intl.NumberFormat('en-US').format(summary.totalValue)} color="bg-blue-100" />		
      </div>
  );
};

const Card = ({
  title,
  value,
  color,
}: {
  title: string;
  value: string | number;
  color: string;
}) => (
  <div className={`p-4 rounded shadow ${color}`}>
    <h3 className="text-sm text-gray-700 font-medium">{title}</h3>
    <p className="text-xl font-bold text-gray-800">{value}</p>
  </div>
);

export default InventoryValueCard;